import React from 'react';
import { Button } from '@getro/rombo';
import { Text, Box, Link } from 'rebass/styled-components';
import NextLink from 'next/link';
import { NetworkSchema } from '../../schema/network';
import MarkdownRenderer from '../../components/atoms/MarkdownRenderer';
import { hasAdvancedDesignSelector } from '../../redux/selectors/network';

export const Complete = ({ network }) => {
  const hasAdvancedDesign = hasAdvancedDesignSelector(network);

  return (
    <>
      {network?.tnSettings?.tnV2SuccessMessageText ? (
        <Box
          mb="32px"
          sx={{
            'li:not(:last-child)': {
              marginBottom: 2,
            },
            p: {
              color: 'text.main',
              lineHeight: '26px',
              fontSize: '18px',
            },
            h1: {
              color: 'text.dark',
              fontSize: '24px',
            },
            h2: {
              color: 'text.dark',
              fontSize: '18px',
              marginTop: 4,
            },
          }}
        >
          <MarkdownRenderer source={network.tnSettings.tnV2SuccessMessageText} />
        </Box>
      ) : (
        <>
          <Text color="text.main" fontSize="16px" lineHeight="1.2" mt="24px">
            We will be in touch when we find a great opportunity for you at one of our companies.
          </Text>
        </>
      )}

      <Box mt="32px" maxWidth="72px">
        <Button
          as={NextLink}
          href="/talent-network"
          passHref
          sx={{
            bg: hasAdvancedDesign ? 'customPrimary' : 'primary',
            '&&:hover': { bg: hasAdvancedDesign ? 'customPrimary' : 'primary' },
          }}
        >
          Ok
        </Button>
      </Box>
      <Text mt="16px" fs="14px" color="text.subtle">
        To delete or edit information shared with us, email{' '}
        <Link color="text.subtle" href="mailto:talent@getro.com" target="_blank" rel="noopener noreferrer">
          talent@getro.com
        </Link>
        .
      </Text>
    </>
  );
};

Complete.propTypes = {
  network: NetworkSchema.isRequired,
};

export default Complete;
